import { lazy } from 'react'

const BrandsRoutes = [
  {
    path: '/login',
    component: lazy(() => import('../../views/pages/authentication/Login')),

    meta: {
      authRoute: true
    }
  },
  {
    path: '/brands/experience',
    component: lazy(() => import('../../views/brands-v2/experience')),

    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'true',
      resource: 'brands_v2',
      contentWidth: 'boxed'
    }
  },
  {
    path: '/brands/kit-creator',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/brands-v2/kitCreator')),
    meta: {
      publicRoute: true,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/preset-packs',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/brands-v2/presetPacks')),
    meta: {
      publicRoute: true,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/especial-packs',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/brands-v2/especialPacks')),
    meta: {
      publicRoute: true,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/onboarding',
    component: lazy(() => import('../../views/brands-v2/onboarding')),
    meta: {
      contentWidth: 'boxed',
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/afterOrder',
    component: lazy(() => import('../../views/brands-v2/afterOrder')),

    meta: {
      contentWidth: 'boxed',
      publicRoute: true,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/subscription/success',
    component: lazy(() => import('../../views/apps/success')),
    meta: {
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/subscription/error',
    component: lazy(() => import('../../views/apps/error')),
    meta: {
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/subscription',
    component: lazy(() => import('../../views/apps/pricing')),
    meta: {
      action: 'true',
      resource: 'brands_v2'
    }
  },

  {
    path: '/brands/account',
    component: lazy(() => import('../../views/brands-v2/account')),
    meta: {
      action: 'true',
      publicRoute: true,
      resource: 'brands_v2',
      contentWidth: 'boxed'
    }
  },
  {
    path: '/brands/inventory',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/inventory')),
    meta: {
      publicRoute: true,
      action: 'list',
      resource: 'inventory'
    }
  },
  {
    path: '/brands/products',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/products')),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'list',
      resource: 'inventory'
    }
  },
  {
    path: '/brands/packages',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/packages')),
    meta: {
      publicRoute: true,
      action: 'list',
      resource: 'inventory_packages'
    }
  },
  {
    path: '/brands/packages/:id',
    className: '',
    component: lazy(() => import('../../views/apps/inventory')),
    meta: {
      action: 'list',
      resource: 'inventory_packages'
    }
  },
  {
    path: '/brands/orders/approve/:id/',
    className: 'ecommerce-application',
    exact: false,
    component: lazy(() => import('../../views/apps/orders/orderApproval')),
    meta: {
      navLink: '/brands/orders/approve/',
      action: 'list',
      resource: 'orders',
      publicRoute: true
    }
  },
  {
    path: '/brands/orders/proposal/:id/',
    exact: true,
    component: lazy(() =>
      import('../../views/apps/orders/orderApproval/BusinessProposal')
    ),
    meta: {
      navLink: '/brands/orders/proposal/',
      action: 'list',
      resource: 'orders',
      publicRoute: true
    }
  },
  {
    path: '/brands/orders/mockups/:id/',
    layout: 'BlankLayout',
    exact: true,
    component: lazy(() =>
      import('../../views/apps/orders/orderApproval/MockupsShowcase')
    ),
    meta: {
      navLink: '/brands/orders/proposal/',
      action: 'list',
      resource: 'orders',
      publicRoute: true
    }
  },
  {
    path: '/brands/orders',
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/apps/orders/orderList')),
    meta: {
      authRoute: false,
      action: 'list',
      resource: 'orders',
      publicRoute: true
    }
  },
  //// logistics

  {
    path: '/brands/create-shipping',
    component: lazy(() => import('../../views/apps/logistics/CreateShipment')),

    meta: {
      authRoute: false,
      action: 'list',
      resource: 'shipments',
      contentWidth: 'boxed'
    }
  },
  {
    path: '/brands/shipping-packages',
    component: lazy(() => import('../../views/apps/logistics/ShippingBatches')),

    meta: {
      authRoute: false,
      action: 'list',
      resource: 'shipments'
    }
  },
  {
    path: '/brands/referral',
    component: lazy(() => import('../../views/brands-v2/indication')),

    meta: {
      authRoute: false,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  // {
  //   path: '/brands/one-shipping',
  //   component: lazy(() => import('../../views/apps/logistics/SingleShipment')),

  //   meta: {
  //     authRoute: false,
  //     action: 'true',
  //     resource: 'brands_v2'
  //   }
  // },
  {
    path: '/brands/giveaway/:id',
    layout: 'BlankLayout',
    component: lazy(() => import('../../views/apps/logistics/giveaway')),
    meta: {
      publicRoute: true,
      // authRoute: true,

      contentWidth: '90%',
      navLink: '/brands/giveaway/',
      action: 'true',
      resource: 'brands_v2'
      // menuHidden:true
    }
  },

  {
    path: '/brands/redeem/:id',
    layout: 'BlankLayout',
    component: lazy(() => import('../../views/apps/logistics/redeem')),
    meta: {
      publicRoute: true,
      // authRoute: true,

      contentWidth: '90%',
      navLink: '/brands/redeem/',
      action: 'true',
      resource: 'brands_v2'
      // menuHidden:true
    }
  },

  {
    path: '/brands/give/:id',
    layout: 'BlankLayout',
    component: lazy(() => import('../../views/apps/logistics/give')),
    meta: {
      publicRoute: true,
      // authRoute: true,

      contentWidth: '90%',
      navLink: '/brands/redeem/',
      action: 'true',
      resource: 'brands_v2'
      // menuHidden:true
    }
  },
  // {
  //   path: '/brands/shipping-packages',
  //   component: lazy(() => import('../../views/brands-v2/packages')),

  //   meta: {
  //     authRoute: false,
  //     action: 'true',
  //     resource: 'brands_v2'
  //   }
  // },

  {
    path: '/brands/shipping-batches',
    component: lazy(() =>
      import('../../views/apps/shippingBatchs/shippingBatchs')
    ),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'list',
      resource: 'shipments'
    }
  },
  {
    path: '/brands/individual-shippings',
    component: lazy(() => import('../../views/apps/shipments/shippings')),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'list',
      resource: 'shipments'
    }
  },
  {
    path: '/single-shippings',
    component: lazy(() =>
      import('../../views/apps/shipmentsSingle/ShipmentsSingle')
    ),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'list',
      resource: 'shipments'
    }
  },
  {
    path: '/analytics',
    component: lazy(() =>
      import('../../views/apps/shipmentAnalytics/ShipmentAnalytics')
    ),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'list',
      resource: 'shipments'
    }
  },
  {
    path: '/contacts',
    component: lazy(() => import('../../views/apps/contacts/ContactsPage')),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'list',
      resource: 'shipments'
    }
  },
  // {
  //   path: '/brands/saldo',
  //   component: lazy(() => import('../../views/brands/balance')),
  //   exact: true,
  //   meta: {
  //     authRoute: false,
  //     action: 'true',
  //     resource: 'brands_v2'
  //   }
  // },
  // {
  //   path: '/brands/saldo/adicionar',
  //   component: lazy(() => import('../../views/brands/balance/add')),
  //   meta: {
  //     authRoute: false,
  //     action: 'true',
  //     resource: 'brands_v2'
  //   }
  // }
  {
    path: '/login',
    component: lazy(() => import('../../views/pages/authentication/Login')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/register',
    component: lazy(() => import('../../views/pages/authentication/Register')),
    layout: 'BlankLayout',
    meta: {
      // authRoute: true,
      publicRoute: true,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/esqueci-minha-senha',
    component: lazy(() =>
      import('../../views/pages/authentication/ForgotPassword')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  // {
  //   path: '/pages/forgot-password-v1',
  //   component: lazy(() => import('../../views/pages/authentication/ForgotPasswordV1')),
  //   layout: 'BlankLayout'
  // },
  // {
  //   path: '/pages/forgot-password-v2',
  //   component: lazy(() => import('../../views/pages/authentication/ForgotPasswordV2.js')),
  //   layout: 'BlankLayout'
  // },
  {
    path: '/reset-senha/:token',
    component: lazy(() =>
      import('../../views/pages/authentication/ResetPasswordV1')
    ),
    layout: 'BlankLayout',
    meta: {
      authRoute: true
    }
  },
  // {
  //   path: '/pages/reset-password-v2',
  //   component: lazy(() => import('../../views/pages/authentication/ResetPasswordV2')),
  //   layout: 'BlankLayout'
  // },
  // {
  //   path: '/pages/profile',
  //   component: lazy(() => import('../../views/pages/profile'))
  // },
  {
    path: '/faq',
    component: lazy(() => import('../../views/brands-v2/faq')),
    meta: {
      publicRoute: true,

      authRoute: false,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/misc/not-authorized',
    component: lazy(() => import('../../views/pages/misc/NotAuthorized')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true
    }
  },
  // {
  //   path: '/misc/maintenance',
  //   component: lazy(() => import('../../views/pages/misc/Maintenance')),
  //   layout: 'BlankLayout',
  //   meta: {
  //     publicRoute: true
  //   }
  // },
  {
    path: '/misc/error',
    component: lazy(() => import('../../views/pages/misc/Error')),
    layout: 'BlankLayout',
    meta: {
      publicRoute: true
    }
  },

  {
    path: '/brands/integration',
    component: lazy(() => import('../../views/apps/integration/page')),
    exact: true,
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/integration/api-conquer',
    component: lazy(() => import('../../views/apps/integration/apiConquer')),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/redeem-pages',
    component: lazy(() => import('../../views/redeem-pages/page')),
    exact: true,
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/brands/redeem-pages/:id',
    component: lazy(() => import('../../views/redeem-pages/$id')),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/feedbacks',
    component: lazy(() => import('../../views/apps/feedbacks/Feedbacks')),
    meta: {
      publicRoute: true,
      authRoute: false,
      action: 'true',
      resource: 'brands_v2'
    }
  },
  {
    path: '/atendimento',
    component: lazy(() => import('../../views/pages/misc/ChatwootPage')),
    meta: {
      publicRoute: false,
      action: 'true',
      resource: 'brands_v2',
      authRedirectUrl: '/login'
    }
  }
]

export default BrandsRoutes
